import React from 'react';

export default function IconHistory() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33350)">
        <path
          d="M12.125 8.31445V12.0645L15.125 14.3145"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.0727 7.63867H6.0727L6.0127 4.63867"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.07227 7.63868C8.51727 4.29368 13.2048 3.56618 16.5498 6.01118C19.8948 8.45618 20.6223 13.1512 18.1773 16.4887C15.7323 19.8337 11.0373 20.5612 7.69977 18.1162"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.69984 18.1179C6.14734 16.9854 5.02984 15.2604 4.71484 13.2129"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33350">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.125 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
